import { PaymentMethodRepositoryInterface } from '../domain/PaymentMethodsRepositoryInterface.types';
import PaymentMethodService from 'src/features/paymentMethods/data/service/PaymentMethodsService';
import { inject, injectable } from 'inversify';
import { GetUserPaymentMethodsParams } from 'src/features/paymentMethods/data/service/PaymentMethodsService.types';

@injectable()
class PaymentMethodRepository implements PaymentMethodRepositoryInterface {
  @inject(PaymentMethodService)
  private readonly paymentMethodService!: PaymentMethodService;

  public async getPaymentMethods(params: GetUserPaymentMethodsParams) {
    const response =
      await this.paymentMethodService.getUserPaymentMethods(params);

    return response.data;
  }
}

export default PaymentMethodRepository;
